import script from "./HomePageUpcomingEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageUpcomingEvents.vue?vue&type=script&setup=true&lang=js"

import "./HomePageUpcomingEvents.vue?vue&type=style&index=0&id=7764a4fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7764a4fd"]])

export default __exports__